"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGraphQl = exports.fetchQuery = void 0;
var fetchQuery_1 = require("./fetchQuery");
Object.defineProperty(exports, "fetchQuery", { enumerable: true, get: function () { return __importDefault(fetchQuery_1).default; } });
var parseGraphQl_1 = require("./parseGraphQl");
Object.defineProperty(exports, "parseGraphQl", { enumerable: true, get: function () { return __importDefault(parseGraphQl_1).default; } });
//# sourceMappingURL=index.js.map